import React, { useCallback, useEffect, useState } from 'react'
import styles from './tab.module.scss'
import { useLocation, useNavigate } from 'react-router-dom'

const Tab = ({ text='', number = null, active = true, onClick = () => null, tabs = [] }) => {

const navigate = useNavigate()
const {pathname,search} = useLocation()
const [activeTab, setActiveTAb] = useState(active)


const stripeStr = str =>  str?.replaceAll(' ','-')?.toLowerCase()

const click = useCallback(()=>{
    // console.log(text)

    const quer =  stripeStr(text)
    const url_search =new URLSearchParams(search)
    url_search.set('tab',quer)
    navigate(`${pathname}?${url_search.toString()}`)

    const indexOfSelected =  tabs.findIndex(tab =>stripeStr(tab) === quer)
    // console.log({indexOfSelected})
    onClick(indexOfSelected)
},[text,tabs])

useEffect(()=>{
    const url_search =new URLSearchParams(search)
    const quer = url_search.get('tab')

    navigate(`${pathname}?${url_search.toString()}`)

    const indexOfSelected =  tabs.findIndex(tab =>stripeStr(tab) === quer)
   if(indexOfSelected===-1) onClick(0)
    if(indexOfSelected >= 0)  onClick(indexOfSelected)

},[search])

    return (
        <div className={`${styles.button} ${active && styles.borderb}`} onClick={()=>click()}>
            <div className={`${styles.textTab} ${active ? styles.textActive : styles.textInactive}`}>{text}</div>
            {number !== null && <div className={styles.numberText}>{number}</div>}
        </div>
    )
}

export default Tab